<template>
  <div class="CARD_Right_Container">
    <div class="CardAsideRight">
      <div class="GlobalPageSet">
        <div class="title gpadding">全局设置</div>
        <div class="subtitle gpadding" style="margin-bottom: -10px">
          答题卡模式
        </div>
        <div class="card-mode gpadding clearfix">
          <div class="card-mode-c" @click="handleModelClick(0)">
            <button class="Selector setting-selector-mode" style="height: 85px; width: 70px" :class="{
              'selector-btn-active': answerSheet.acCardStudentCodeType == '0',
            }">
              <img class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC6CAYAAABBccToAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjkzMDg2QTIzODc1MjExRUVCNzhEQjVCMkM3MjZDMzEzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjkzMDg2QTI0ODc1MjExRUVCNzhEQjVCMkM3MjZDMzEzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OTMwODZBMjE4NzUyMTFFRUI3OERCNUIyQzcyNkMzMTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OTMwODZBMjI4NzUyMTFFRUI3OERCNUIyQzcyNkMzMTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7yb6t/AAABvUlEQVR42uzdQQrCMBBA0USycyFe3zt5lVqhrtOmtPswtiD4HogbV8OHAWNqHsapJpp8v127Pvh4rm/mtrgYAQJCQAgIAYGAEBACQkAgIASEgBAQCAgBISAEBAJCQAgIASEgEBACQkAICASEgBAQAgIBISAEhIBAQByjLK9sDIQD6n2wJFhhCAgBISAQEAJCQAgIAUFIeb0/prDxrXwgoOR/r3bOBK0wBISAEBAICAEhIAQEAkJACAgBgYAQEAJCQAgIBISAEBB/phhBmB/htyEM4+RWxjYL13qsMASEgBAQCAgBISAEBALiBI4yAjyUS0BHcARkhSEgBISAEBAICAEhIAQEAkJA/LZ2FuZ+U4y5tSHU6kwQKwwBISAEBAJCQAgIAYGAOFFxx4mvAkruN2GFISAEhIBAQAgIASEgEBACQkAICASEgBAQAgIBISAEhIAQEAgIASEgBAQCQkAICAGBgBAQAkJAICAEhIAQEAICASEgBISAQEAICAEhIBAQAkJACAgEhIAQEAJCQEaAgBAQAkJAICAEhIAQEAgIASEgBAQCQkAICAGBgBAQAkJACAgEhIAQEAKCLrMAAwAP/Rq6bUXLFgAAAABJRU5ErkJggg==" />
            </button>
            <div class="card-mode-c-name-ac card-mode-c-name">涂点</div>
          </div>
          <div class="card-mode-c" @click="handleModelClick(2)">
            <button class="Selector setting-selector-mode" style="height: 85px; width: 70px" :class="{
              'selector-btn-active': answerSheet.acCardStudentCodeType == '2',
            }">
              <img class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC6CAYAAABBccToAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBBQURGNTI3OUFGNTExRUVCRDVFRkE5NzRDRTQ2RjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBBQURGNTI4OUFGNTExRUVCRDVFRkE5NzRDRTQ2RjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEFBREY1MjU5QUY1MTFFRUJENUVGQTk3NENFNDZGMkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEFBREY1MjY5QUY1MTFFRUJENUVGQTk3NENFNDZGMkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz56sITdAAABd0lEQVR42uzcMQrAIAxA0aZ4/7138i7FwTm69AIBl/Ie5ALhQwbBeHrmBUW3FSAgBISAEBAICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBACAgEhIASEgEBACAgB8WdtT1gDVZF+d8EJQ0AICAGBgBAQAkJAICBOau+YtkA9oD3eMnDCEBACQkAgIASEgBAQCAgBISAEBAJCQAgIAYGAEBACQkAICASEgBAQAgIBISAEhIBAQAgIASEgEBACQkAICAGBgBAQAkJAICAEhIAQEAgIASEgBAQCQkAICAEhIBAQAkJACAgEhIAQEAICASEgBISAQEAICAEhIBAQAkJACAgBgYAQEAJCQCAgBISAEBAICAEhIAQEAkJACAgBISAQEAJCQAgIBISAEBACAgEhIASEgEBACAgBISAEBAJCQAgIAYGAEBACQkAgIASEgBAQCAgBISAEBAJCQAgIASEgEBACQkAICASEgBAQAgIBISAEhIDgswQYAIZsC66o0lc9AAAAAElFTkSuQmCC" />
            </button>
            <div class="card-mode-c-name">手写</div>
          </div>
          <div class="card-mode-c" @click="handleModelClick(1)">
            <button class="Selector setting-selector-mode" style="height: 85px; width: 70px" :class="{
              'selector-btn-active': answerSheet.acCardStudentCodeType == '1',
            }">
              <img class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC3CAYAAAD979c2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkFDMjYzOUQ4ODc1MjExRUU4N0ZBQjVDQUZGQzlDMzdCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkFDMjYzOUQ5ODc1MjExRUU4N0ZBQjVDQUZGQzlDMzdCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QUMyNjM5RDY4NzUyMTFFRTg3RkFCNUNBRkZDOUMzN0IiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QUMyNjM5RDc4NzUyMTFFRTg3RkFCNUNBRkZDOUMzN0IiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5jgd/mAAABlElEQVR42uzcOwqAMBBAwUTsLMTreyev4ge0joJirREtZAbSWS0PthA29uOcAmQqjAABISAEhIBAQAgIASEgEBACQkAICASEgBAQAgIBISAEhIAQEAgIASEgBAQCQkAIiD8rtxeNgVwxJdddsMIQEAJCQCAgBISAEBAIiBeVw7SYwqGpq0vftZ1ZnQFtz7+M3d1/guZmhSEgBISAEBAICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBACAgEhIASEgEBACAgB8Xcu1eczt+BSPVYYAkJACAgEhIAQEAICAfE2l+p5FlBwcR0rDAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBAICAEhIASEgEBACAgBISAQEAJCQAgIBISAEBACAgEhIASEgBAQCAgBISAEBAJCQAgIAYGAEBACQkAgIASEgBAQAjICBISAEBACAgEhIASEgEBACAgBISAQEAJCQAgIBISAEBACQkAgIASEgBAQCAgBISAEBAJCQAgIAYGAEBACQkAICASEgBAQAgIB8ZFVgAEAh+cVgBy+irkAAAAASUVORK5CYII=" />
            </button>
            <div class="card-mode-c-name">条码</div>
          </div>
          <!-- <div v-if="false" class="card-mode-c" @click="handleModelClick(3)">
            <button
              class="Selector setting-selector-mode"
              style="height: 85px; width: 70px"
              :class="{
                'selector-btn-active': answerSheet.acCardStudentCodeType == '3',
              }"
            >
              <img
                class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC3CAYAAAD979c2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkFDMjYzOUQ4ODc1MjExRUU4N0ZBQjVDQUZGQzlDMzdCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkFDMjYzOUQ5ODc1MjExRUU4N0ZBQjVDQUZGQzlDMzdCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QUMyNjM5RDY4NzUyMTFFRTg3RkFCNUNBRkZDOUMzN0IiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QUMyNjM5RDc4NzUyMTFFRTg3RkFCNUNBRkZDOUMzN0IiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5jgd/mAAABlElEQVR42uzcOwqAMBBAwUTsLMTreyev4ge0joJirREtZAbSWS0PthA29uOcAmQqjAABISAEhIBAQAgIASEgEBACQkAICASEgBAQAgIBISAEhIAQEAgIASEgBAQCQkAIiD8rtxeNgVwxJdddsMIQEAJCQCAgBISAEBAIiBeVw7SYwqGpq0vftZ1ZnQFtz7+M3d1/guZmhSEgBISAEBAICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBACAgEhIASEgEBACAgB8Xcu1eczt+BSPVYYAkJACAgEhIAQEAICAfE2l+p5FlBwcR0rDAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBAICAEhIASEgEBACAgBISAQEAJCQAgIBISAEBACAgEhIASEgBAQCAgBISAEBAJCQAgIAYGAEBACQkAgIASEgBAQAjICBISAEBACAgEhIASEgEBACAgBISAQEAJCQAgIBISAEBACQkAgIASEgBAQCAgBISAEBAJCQAgIAYGAEBACQkAICASEgBAQAgIB8ZFVgAEAh+cVgBy+irkAAAAASUVORK5CYII="
              />
            </button>
            <div class="card-mode-c-name">条码2</div>
          </div> -->
          <!-- <div v-if="false" class="card-mode-c" @click="handleModelClick(4)">
            <button
              class="Selector setting-selector-mode"
              style="height: 85px; width: 70px"
              :class="{
                'selector-btn-active': answerSheet.acCardStudentCodeType == '4',
              }"
            >
              <img
                class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC6CAYAAABBccToAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkMzODA3RjA2ODc1MjExRUU5ODA4Rjc5NkJBOTdERjY1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkMzODA3RjA3ODc1MjExRUU5ODA4Rjc5NkJBOTdERjY1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzM4MDdGMDQ4NzUyMTFFRTk4MDhGNzk2QkE5N0RGNjUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzM4MDdGMDU4NzUyMTFFRTk4MDhGNzk2QkE5N0RGNjUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5rOyawAAABvElEQVR42uzcvQrCMBSA0US6dRBf33fyVfwBO18bq9CxTWmHcA6Ii9Plg4AhN9+f70gU+XLuF/3wevt+mdvoZAQICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBAICAEhIASEgEBACAgBISAQEAJCQLSsGz/ZGKqYWxlChC0lOMIQEAJCQCAgBISAEBAIiB11j9dgCj8rF42TprswdxmTtXdb5uYIQ0AICAEhIBAQAkJACAgEhIAQEAICASEgBISAQEAICAEhIAQEAkJACAgBgYAQEAKidTbVsy2gpTtxwBGGgBAQAgIBISAEhIAQEFSxqX7Gv/IVASUb1//cCTrCEBACQkAgIASEgBAQCAgBISDa4l1YPXMrQ4hwl4ojDAEhIAQEAkJACAgBgYDYkXdhbAsoeReGIwwBISAEBAJCQAgIAYGAEBACQkAgIASEgBAQCAgBISAEhIBAQAgIASEgEBACQkAICASEgBAQAgIBISAEhIAQEAgIASEgBAQCQkAICAGBgBAQAkJAICAEhIAQEAIyAgSEgBAQAgIBISAEhIBAQAgIASEgEBACQkAICASEgBAQAkJAICCO9hFgAI87HE1tGSUOAAAAAElFTkSuQmCC"
              />
            </button>
            <div class="card-mode-c-name">条码+涂点</div>
          </div> -->
          <!-- <div v-if="false" class="card-mode-c" @click="handleModelClick(5)">
            <button
              class="Selector setting-selector-mode"
              style="height: 85px; width: 70px"
              :class="{
                'selector-btn-active': answerSheet.acCardStudentCodeType == '5',
              }"
            >
              <img
                class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC3CAYAAAD979c2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQwODkwOTMxODc1MjExRUVBMTk0Rjc4QUNEOERDMUI4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQwODkwOTMyODc1MjExRUVBMTk0Rjc4QUNEOERDMUI4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDA4OTA5MkY4NzUyMTFFRUExOTRGNzhBQ0Q4REMxQjgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDA4OTA5MzA4NzUyMTFFRUExOTRGNzhBQ0Q4REMxQjgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz717HrJAAABg0lEQVR42uzcywnAIBBAQQ32X0B6Siv5QHI2FuBpxRzCDNjA8mAPwub9vGuCoMUIEBACQkAICASEgBAQAgIBISAEhIBAQAgIASEgEBACQkAICAGBgBAQAkJAICAEhID4s9JeNgaicq2uu2CFISAEhIBAQAgIASEgEBATleN6TIF4QO35y8AKQ0AICAGBgBAQAkJAICAEhIAQEAgIASEgBAQCQkAICAEhIBAQAkJACAgEhIAQEAKCHpfqGeJSPVYYAkJACAgEhIAQEAICATFXWTdDYCCg5FI9VhgCQkAICASEgBAQAgIBISAEhIBAQAgIASEgEBACQkAICAGBgBAQAkJAICAEhIAQEAgIASEgBAQCQkAICAEhIBAQAkJACAgEhIAQEAICASEgBISAQEAICAEhIARkBAgIASEgBAQCQkAICAGBgBAQAkJAICAEhIAQEAgIASEgBISAQEAICAEhIBAQAkJACAgEhIAQEAICASEgBISAEBAICAEhIAQEAuIjrwADAMrlEX8Owh+6AAAAAElFTkSuQmCC"
              />
            </button>
            <div class="card-mode-c-name">手写2</div>
          </div> -->
          <!-- <div class="card-mode-c" @click="handleModelClick(6)">
            <button
              class="Selector setting-selector-mode"
              style="height: 85px; width: 70px"
              :class="{
                'selector-btn-active': answerSheet.acCardStudentCodeType == '6',
              }"
            >
              <img
                class="card-mode-img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAC6CAYAAABBccToAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc1NjE1M0Y4QTA5RTExRUVBNUJBRkI4N0RFNzI4NTZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc1NjE1M0Y5QTA5RTExRUVBNUJBRkI4N0RFNzI4NTZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzU2MTUzRjZBMDlFMTFFRUE1QkFGQjg3REU3Mjg1NkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzU2MTUzRjdBMDlFMTFFRUE1QkFGQjg3REU3Mjg1NkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz49KwvXAAABcklEQVR42uzSoQ1AIQxAQWAldmIndmKXny/QEDZAgCC5MzUVTfNibWOEu2LJe4vf39e4fQ8HJS9AQAgIASEgEBACQkAICASEgBAQAgIBISAEhIBAQAgIASEgBAQCQkAICAGBgBAQAkJAICAEhIAQEAgIASEgBISAQEAICAEhIBAQAkJACAgEhIAQEAICASEgBISAQEAICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAEBAICAEhIASEgEBACAgBISAQEAJCQAgIBISAEBACAgEhIASEgBAQCAgBISAEBAJCQAgIAYGAEBACQkAgIASEgBAQCAgBISAEhIBAQAgIASEgEBACQkAICASEgBAQAgIBISAEhIAQEAgIASEgBAQCQkAICAGBgBAQAkJAICAEhIAQEAICASEgBISAQEAICAEhIBAQAkJACAgEhIAQEAICASEgBISAEBAICAEhIAQEAkJACAgBgYAQEAJCQCAgBISAeNsUYAB51QlFKyI7oAAAAABJRU5ErkJggg=="
              />
            </button>
            <div class="card-mode-c-name">封装线</div>
          </div> -->
        </div>
        <div class="el-divider el-divider--horizontal" role="separator" style="--el-border-style: solid">
          <!--v-if-->
        </div>
        <div class="subtitle gpadding">答题卡布局</div>
        <div class="card-Layout-container gpadding">
          <div class="card-layout" :class="{ 'card-layout-active': answerSheet.acCardPanes == 1 }"
            @click="hurdleChange(1)">
            <div class="card-layout-pic card-layout-one"></div>
            <div>一栏</div>
          </div>
          <div class="card-layout" :class="{ 'card-layout-active': answerSheet.acCardPanes == 2 }"
            @click="hurdleChange(2)">
            <div class="card-layout-pic card-layout-two">
              <div class="line"></div>
            </div>
            <div>两栏</div>
          </div>
          <div class="card-layout" :class="{ 'card-layout-active': answerSheet.acCardPanes == 3 }"
            @click="hurdleChange(3)">
            <div class="card-layout-pic card-layout-thr">
              <div class="line"></div>
              <div class="line"></div>
            </div>
            <div>三栏</div>
          </div>
        </div>
        <div class="card-layout-tips gpadding">
          <span v-if="answerSheet.acCardPanes == 1">一栏适用于A4、16K、B5纸张</span>
          <span v-if="answerSheet.acCardPanes == 2 || answerSheet.acCardPanes == 3">{{
            `${answerSheet.acCardPanes == 2 ? "两" : "三"
            }栏适用于A3、8K、B4纸张`
          }}</span>
        </div>
        <div class="el-divider el-divider--horizontal" role="separator" style="--el-border-style: solid">
          <!--v-if-->
        </div>
        <div v-if="false" class="subtitle gpadding">边距设置</div>
        <div v-if="false" class="card-margin gpadding clearfix" style="margin-top: -10px">
          <div class="card-margin-item">
            <span>上边距:</span>
            <div class="el-select el-select--small card-margin-item-Select">
              <div class="select-trigger el-tooltip__trigger el-tooltip__trigger">
                <!--v-if--><!-- fix: https://github.com/element-plus/element-plus/issues/11415 --><!--v-if-->
                <div class="el-input el-input--small el-input--suffix">
                  <!-- input --><!-- prepend slot --><!--v-if-->
                  <div class="el-input__wrapper" tabindex="-1">
                    <!-- prefix slot --><!--v-if--><input class="el-input__inner" type="text" readonly=""
                      autocomplete="off" tabindex="0" placeholder="请选择" id="el-id-1202-46" /><!-- suffix slot --><span
                      class="el-input__suffix"><span class="el-input__suffix-inner"><i
                          class="el-icon el-select__caret el-select__icon"><svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                              d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                            </path>
                          </svg></i><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--></span></span>
                  </div>
                  <!-- append slot --><!--v-if-->
                </div>
              </div>
            </div>
          </div>
          <div class="card-margin-item">
            <span>下边距:</span>
            <div class="el-select el-select--small card-margin-item-Select">
              <div class="select-trigger el-tooltip__trigger el-tooltip__trigger">
                <!--v-if--><!-- fix: https://github.com/element-plus/element-plus/issues/11415 --><!--v-if-->
                <div class="el-input el-input--small el-input--suffix">
                  <!-- input --><!-- prepend slot --><!--v-if-->
                  <div class="el-input__wrapper" tabindex="-1">
                    <!-- prefix slot --><!--v-if--><input class="el-input__inner" type="text" readonly=""
                      autocomplete="off" tabindex="0" placeholder="请选择" id="el-id-1202-47" /><!-- suffix slot --><span
                      class="el-input__suffix"><span class="el-input__suffix-inner"><i
                          class="el-icon el-select__caret el-select__icon"><svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                              d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                            </path>
                          </svg></i><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--></span></span>
                  </div>
                  <!-- append slot --><!--v-if-->
                </div>
              </div>
            </div>
          </div>
          <div class="card-margin-item">
            <span>左边距:</span>
            <div class="el-select el-select--small card-margin-item-Select">
              <div class="select-trigger el-tooltip__trigger el-tooltip__trigger">
                <!--v-if--><!-- fix: https://github.com/element-plus/element-plus/issues/11415 --><!--v-if-->
                <div class="el-input el-input--small el-input--suffix">
                  <!-- input --><!-- prepend slot --><!--v-if-->
                  <div class="el-input__wrapper" tabindex="-1">
                    <!-- prefix slot --><!--v-if--><input class="el-input__inner" type="text" readonly=""
                      autocomplete="off" tabindex="0" placeholder="请选择" id="el-id-1202-48" /><!-- suffix slot --><span
                      class="el-input__suffix"><span class="el-input__suffix-inner"><i
                          class="el-icon el-select__caret el-select__icon"><svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                              d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                            </path>
                          </svg></i><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--></span></span>
                  </div>
                  <!-- append slot --><!--v-if-->
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="card-margin-item">
            <span>右边距:</span>
            <div class="el-select el-select--small card-margin-item-Select">
              <div class="select-trigger el-tooltip__trigger el-tooltip__trigger">
                <!--v-if--><!-- fix: https://github.com/element-plus/element-plus/issues/11415 --><!--v-if-->
                <div class="el-input el-input--small el-input--suffix">
                  <!-- input --><!-- prepend slot --><!--v-if-->
                  <div class="el-input__wrapper" tabindex="-1">
                    <!-- prefix slot --><!--v-if--><input class="el-input__inner" type="text" readonly=""
                      autocomplete="off" tabindex="0" placeholder="请选择" id="el-id-1202-49" /><!-- suffix slot --><span
                      class="el-input__suffix"><span class="el-input__suffix-inner"><i
                          class="el-icon el-select__caret el-select__icon"><svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                              d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                            </path>
                          </svg></i><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--></span></span>
                  </div>
                  <!-- append slot --><!--v-if-->
                </div>
              </div>
            </div>
          </div>
          <div class="card-margin-item">
            <span style="margin-left: -10px">模块边距:</span>
            <div class="el-select el-select--small card-margin-item-Select">
              <div class="select-trigger el-tooltip__trigger el-tooltip__trigger">
                <!--v-if--><!-- fix: https://github.com/element-plus/element-plus/issues/11415 --><!--v-if-->
                <div class="el-input el-input--small el-input--suffix">
                  <!-- input --><!-- prepend slot --><!--v-if-->
                  <div class="el-input__wrapper" tabindex="-1">
                    <!-- prefix slot --><!--v-if--><input class="el-input__inner" type="text" readonly=""
                      autocomplete="off" tabindex="0" placeholder="请选择" id="el-id-1202-50" /><!-- suffix slot --><span
                      class="el-input__suffix"><span class="el-input__suffix-inner"><i
                          class="el-icon el-select__caret el-select__icon"><svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1024 1024">
                            <path fill="currentColor"
                              d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
                            </path>
                          </svg></i><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--></span></span>
                  </div>
                  <!-- append slot --><!--v-if-->
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
        <div class="subtitle gpadding">答题卡颜色</div>
        <div class="card-color gpadding clearfix">
          <button class="Selector" :class="{
            ' selector-btn-active': answerSheet.acCardColor == '#333333',
          }" style="margin-right: 15px; height: 45px; width: 45px" @click="cardColorChange('#333333')">
            <div class="cardcolor-exp" style="background-color: rgb(51, 51, 51)"></div>
          </button>
          <button class="Selector" :class="{
            'selector-btn-active': answerSheet.acCardColor == '#ff2020',
          }" style="margin-right: 15px; height: 45px; width: 45px">
            <div class="cardcolor-exp" style="background-color: rgb(255, 32, 32)" @click="cardColorChange('#ff2020')">
            </div>
          </button><button class="Selector" style="margin-right: 15px; height: 45px; width: 45px"
            @click="cardColorChange('#e61dad')" :class="{
              'selector-btn-active': answerSheet.acCardColor == '#e61dad',
            }">
            <div class="cardcolor-exp" style="background-color: rgb(230, 29, 173)"></div>
          </button><button class="Selector" :class="{
            'selector-btn-active': answerSheet.acCardColor == '#259f3b',
          }" style="margin-right: 15px; height: 45px; width: 45px" @click="cardColorChange('#259f3b')">
            <div class="cardcolor-exp" style="background-color: rgb(37, 159, 59)"></div>
          </button>
        </div>
        <div class="el-divider el-divider--horizontal" role="separator" style="--el-border-style: solid">
          <!--v-if-->
        </div>
        <div class="subtitle gpadding" style="margin-bottom: -10px">
          批阅模式
        </div>
        <div class="card-mode gpadding clearfix">
          <button class="Selector setting-pymode" :class="{ 'selector-btn-active': answerSheet.acCardYJType == 1 }"
            style="height: 33px; width: 75px" @click="cardYJTypeChange(1)">
            网阅</button><button class="Selector setting-pymode" style="height: 33px; width: 75px"
            :class="{ 'selector-btn-active': answerSheet.acCardYJType == 0 }" @click="cardYJTypeChange(0)">
            手批
          </button>
          <button class="Selector setting-pymode" :class="{ 'selector-btn-active': answerSheet.acCardYJType == 2 }"
            style="height: 33px; width: 75px" @click="cardYJTypeChange(2)">
            打分
          </button>
        </div>
        <div class="el-divider el-divider--horizontal" role="separator" style="--el-border-style: solid">
          <!--v-if-->
        </div>
        <div class="t-item">
          <div class="subtitle gpadding clearfix" style="margin-bottom: -10px">
            考号
          </div>
          <div class="card-setting exam-num flex">
            <span class="c-gray-999">考号位数</span>
            <el-input-number size="mini" v-model="answerSheet.acCardExamNumber" :min="4"
              :max="maxCardExamNumberComputed" style="float: right" @change="codeNumChange"></el-input-number>
          </div>
        </div>
        <div class="el-divider el-divider--horizontal" role="separator" style="--el-border-style: solid">
          <!--v-if-->
        </div>
        <div class="subtitle gpadding clearfix" style="margin-bottom: -10px">
          其他配置
        </div>
        <div class="card-setting gpadding">
          <!-- <button
            class="Selector selector-btn-active setting-selector"
            style="height: 33px; width: 75px"
          >
            显示页脚
            </button
          ><button
            class="Selector selector-btn-active setting-selector"
            style="height: 33px; width: 100px"
          >
            显示作答区域
          </button
          > -->
          <button class="Selector setting-selector" :class="{ 'selector-btn-active': answerSheet.acCardMissSign }"
            style="height: 33px; width: 75px" @click="absentChange">
            缺考标记
          </button>
          <button class="Selector setting-selector" :class="{ 'selector-btn-active': answerSheet.acCardHideScore }"
            style="height: 33px; width: 75px" @click="cardHideScoreChange">
            隐藏分值
          </button>
          <button class="Selector setting-selector" :class="{ 'selector-btn-active': answerSheet.acCardABSet }"
            style="height: 33px; width: 75px" @click="acCardABSetChange">
            显示AB卷
          </button>

          <button class="Selector setting-selector" :class="{ 'selector-btn-active': myAcCardPint }"
            style="height: 33px; width: 75px" @click="acCardPintChange">
            单面打印
            <el-tooltip class="item" effect="dark" content="打印方式设置会影响每页考生信息的显示，请按照实际情况设置" placement="top-start">
              <div class="el-icon-warning-outline"></div>
            </el-tooltip>
          </button>
          <button class="Selector setting-selector" :class="{ 'selector-btn-active': acCardHideOrcode }"
            style="height: 33px; width: 95px" @click="acCardHideOrcodeChange">
            隐藏二维码
          </button>
          <button class="Selector setting-selector" :class="{ 'selector-btn-active': answerSheet.acCardAutoMerge }"
            style="height: 33px; width: 95px" @click="acCardAutoMergeChange">
            客观题自动合并
          </button>
          <!-- <button class="Selector setting-selector" :class="{ 'selector-btn-active': answerSheet.acCardSpacing }"
            style="height: 33px; width: 95px" @click="acCardSpacingChange">
            小间距模式
            <el-tooltip class="item" effect="dark" content="启用后会使用紧凑的排版，适用于试卷空间较小的场景。" placement="top-start">
              <div class="el-icon-warning-outline"></div>
            </el-tooltip>
          </button> -->
        </div>
        <div class="el-divider el-divider--horizontal" role="separator" style="--el-border-style: solid">
          <!--v-if-->
        </div>
        <div class="subtitle gpadding clearfix">试题列表</div>
        <SubjectList></SubjectList>
        <div class="el-divider el-divider--horizontal" role="separator"
          style="--el-border-style: solid; margin-top: 4px; margin-bottom: 2px">
          <!--v-if-->
        </div>
      </div>
      <!----><!----><!----><!----><!----><!----><!----><!---->
    </div>
  </div>
</template>
<script>
/** 右侧菜单栏 */
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { setObjectiveHeight, getChinese } from "@/utils/common";
import { ObjectiveModel } from "@/subjects/objective/Objective.model";

import SubjectChoose from "@/subjects/choose/Choose";
import SubjectList from "./card/subject-list.vue";
export default {
  components: { SubjectList },
  data() {
    return {
      modelType: 0,
      cacheAcCardPanes: 0,
      updateSubject: undefined,
      updateSubjectIdx: 0,
      subjectsTotalScore: 0,
      subjectsTotalNum: 0,
      isEdit: false,
      //allIndex: null,
      localityAnswerSheet: {
        acCardName: "答题卡",
        acCardPanes: "1", //布局：1、一栏，2、二栏，3三栏
        acCardYJType: 1, //评阅方式：1、手批，2网阅
        acCardStudentCodeType: 0, //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号
        acCardExamNumber: 8, //考号位数
        acCardMissSign: true, //缺考标记：显示-true，隐藏-false
        acCardHideScore: false, //隐藏分值：显示-true，隐藏-false
        acCardPint: 2, //单面打印：1-单面  2-双面
        acCardABSet: false, //AB卷：开启-true，关闭-false
        acRedCard: false, // 是否红色答题卡
      },
      oldAnswerSheet: [1],
      tabsName: "first",
      ABModel: true,
      ABList: [
        {
          qid: "01",
          ans: "A",
        },
        {
          qid: "02",
          ans: "A",
        },
        {
          qid: "01",
          ans: "A",
        },
        {
          qid: "02",
          ans: "A",
        },
        {
          qid: "01",
          ans: "A",
        },
        {
          qid: "02",
          ans: "A",
        },
      ],
      cacheAcCardPanes: 1, // 布局模式
      myAcCardPint: false, // 单面打印
      acCardHideOrcode: true,
    };
  },
  created() {
    if (this.answerSheet.acCardHideOrcode) {
      this.acCardHideOrcode = this.answerSheet.acCardHideOrcode;
    }

  },

  computed: {

    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
      visibleDialog: "answerPanel/visibleDialog",
      visibleDialogIndex: "answerPanel/visibleDialogIndex",
    }),
    ...mapState("card", {
      subjects: (state) => state.subjects,
      pageCell: (state) => state.pageCell,
    }),
    ...mapState("cardMake", [
      "topicStoreroom",
      "cardLoading",
      "objectiveDV",
      "fillDV",
      "answerDV",
      "chooseDV",
      "writingEnDV",
      "writingDV",
      "allIndex",
      "answerSheetMut",
    ]), ////答卷设置参数

    maxCardExamNumberComputed() {
      let maxCardExamNumber = 18;
      if (this.answerSheet.acCardStudentCodeType === 0) {
        maxCardExamNumber = 14;
        if (this.answerSheet.acCardPanes == 3) {
          maxCardExamNumber = 12;
        }
      }
      if (
        this.answerSheet.acCardStudentCodeType === 1 &&
        this.answerSheet.acCardPanes == 3
      ) {
        maxCardExamNumber = 9;
      }
      return maxCardExamNumber;
    },
    worList() {
      let list = [];
      this.topicStoreroom.forEach((topic, topicIndex) => {
        if (topic && topic.typesItem) {
          list.push(topic);
        }
      });

      return list;
    },
    subjectsTotal() {
      let num = 0;
      let score = 0;
      const obj = {};
      
      this.subjects.length &&
        this.subjects.forEach((subject) => {
          score += Number(subject.totalScore || 0);
          subject.items &&
            subject.items.forEach(() => {
              num += 1;
            });
        });
      obj.subjectsTotalScore = score;
      obj.subjectsTotalNum = num;
      obj.tableData = JSON.parse(JSON.stringify(this.subjects)) || [];
      return obj;
    },
    getChinsesCardName() {
      return getChinese(this.answerSheet.acCardName);
    },
  },

  methods: {
    ...mapActions({
      answerSheetAction: "answerPanel/answerSheetAction",
      toogleScore: "answerPanel/toogleScore",
      setVisibleDialog: "answerPanel/setVisibleDialog",
    }),
    ...mapMutations({
      updatePageCellByHurdle: "card/updatePageCellByHurdle",
      changePageWidthByHurlde: "card/changePageWidthByHurlde",
      objectiveFromMut: "cardMake/objectiveFromMut",
      objectiveDVMut: "cardMake/objectiveDVMut",
      fillDVMut: "cardMake/fillDVMut",
      answerDVMut: "cardMake/answerDVMut",
      chooseDVMut: "cardMake/chooseDVMut",
      writingEnDVMut: "cardMake/writingEnDVMut",
      writingDVMut: "cardMake/writingDVMut",
      isBoxEditMut: "cardMake/isBoxEditMut",
      allIndexMut: "cardMake/allIndexMut",
      addSubject: "card/addSubject",
      // append: "subjects/append",
      append: "card/append",
      resetPageCell: "card/resetPageCell",
      resetPageCellContentHeight: "card/resetPageCellContentHeight",
      deleteSubject: "card/deleteSubject",
      updateSubjects: "card/updateSubjects",
      sortSubjectByIndex: "card/sortSubjectByIndex",
      restorePageCell: "card/restorePageCell",
    }), //参数的变动

    acCardAutoMergeChange() {
      let str = !this.answerSheet.acCardAutoMerge
        ? "修改后后续客观题会自动合并到第一个客观题"
        : "修改后后续客观题不会自动合并";
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.answerSheetAction({
          acCardAutoMerge: !this.answerSheet.acCardAutoMerge,
        });
      });
    },
    acCardWriteTitleChange() {
      let str = !this.answerSheet.acCardWriteTitle
        ? "修改后语文作文题目不会显示在答题卡上"
        : "修改后语文作文题目会显示在答题卡上";
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.answerSheetAction({
          acCardWriteTitle: !this.answerSheet.acCardWriteTitle,
        });
      });
    },
    acCardABSetChange(v) {
      this.answerSheetAction({ acCardABSet: v });
    },
    handleModelClick(modelType) {
      this.modelType = Number(modelType);
      this.$emit("basicChange", Number(modelType));
      this.answerSheet.acCardStudentCodeType = Number(modelType);
      this.examNumInfo(Number(modelType));
      //切换后更新答题卡，更新尺寸
      // this.resetPageCell({
      //   acCardStudentCodeType: modelType,
      //   acCardPanes:  this.answerSheet.acCardPanes,
      //   index: 0,
      // })
    },
    reloadPageCell() {
      const restorePageCell = JSON.parse(sessionStorage.getItem("pageCell"));
      const subjects = JSON.parse(sessionStorage.getItem("subjects"));
      this.restorePageCell({
        pageCell: this.answerSheet.pageCell,
        subjects: this.answerSheet.subjects,
        acCardStudentCodeType: this.answerSheet.acCardStudentCodeType,
      });
    },
    examNumInfo(v) {
      //
      this.answerSheetAction({ acCardStudentCodeType: v });
      let pageData = {
        isDefault: false, //是否切换栏数了
      };
      this.changeCardStudentCode();
      // this.resetPageCell({
      //   acCardPanes: this.answerSheet.acCardPanes,
      // });
    },

    changeCardStudentCode(acCardPanes) {
      if (
        acCardPanes == 3 &&
        this.answerSheet.acCardStudentCodeType === 0 &&
        this.answerSheet.acCardExamNumber >= 9
      ) {
        // 三栏
        this.answerSheetAction({ acCardExamNumber: 9 });
      }
      if (
        acCardPanes != 3 &&
        this.answerSheet.acCardStudentCodeType === 0 &&
        this.answerSheet.acCardExamNumber >= 14
      ) {
        // 三栏
        this.answerSheetAction({ acCardExamNumber: 14 });
      }
    },
    //改变栏数
    hurdleChange(val) {
      this.$confirm("修改后自定义编辑的内容会消失，确定修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cacheAcCardPanes = val;
          this.answerSheetAction({ acCardPanes: val });
          this.changeCardStudentCode(val);
          // this.changePageWidthByHurlde({ acCardPanes: val });
          // this.resetPageCell(val);
          this.subjects.forEach(async (subject, index) => {
            if (subject.type == 2) {
              // 这里确保一张答题卡最好只有一种题型是选择题 这样循环指挥执行一次 resetpagecell 渲染页面
              // 将客观题横竖排的rowList更新 这里的subject里面需要newData.diffLayout
              subject = await setObjectiveHeight(subject, subject);
              this.updateSubjects({
                index: index,
                data: new ObjectiveModel(subject),
              });
              this.resetPageCell({
                acCardPanes: val,
                hurdleReset: true,
              });
            }
          });

          this.resetPageCell({
            acCardPanes: val,
            hurdleReset: true,
          });
          // this.updatePageCellByHurdle({});
          // this.writeModel.render();
          // render之后对象属性已经更新 需要把store里面的数据重新更新
          // 可以将所有题型都重新写入一个方法叫做updateDataByHurdle
          this.oldAnswerSheet[0] = val;
          let pageData = {
            isDefault: true, //是否切换栏数了
          };
          // cardOperate.operatePageCell(pageData).then((data) => {
          //   this.localityAnswerSheet = JSON.parse(
          //     JSON.stringify(this.answerSheet)
          //   );
          // });
        })
        .catch(() => {
          this.answerSheetAction({ acCardPanes: this.cacheAcCardPanes });
          // this.localityAnswerSheet.acCardPanes = this.oldAnswerSheet[0];
        });
    },

    hurdleChanges(val) {
      this.$confirm("修改后自定义编辑的内容会消失，确定修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cacheAcCardPanes = val;
          this.answerSheetAction({ acCardPanes: val });
          this.changeCardStudentCode(val);
          // this.changePageWidthByHurlde({ acCardPanes: val });
          // this.resetPageCell(val);
          this.subjects.forEach(async (subject, index) => {
            if (subject.type == 2) {
              // 这里确保一张答题卡最好只有一种题型是选择题 这样循环指挥执行一次 resetpagecell 渲染页面
              // 将客观题横竖排的rowList更新 这里的subject里面需要newData.diffLayout
              subject = await setObjectiveHeight(subject, subject);
              this.updateSubjects({
                index: index,
                data: new ObjectiveModel(subject),
              });
              this.resetPageCell({
                acCardPanes: val,
                hurdleReset: true,
              });
            }
          });

          this.resetPageCell({
            acCardPanes: val,
            hurdleReset: true,
          });
          // this.updatePageCellByHurdle({});
          // this.writeModel.render();
          // render之后对象属性已经更新 需要把store里面的数据重新更新
          // 可以将所有题型都重新写入一个方法叫做updateDataByHurdle
          this.oldAnswerSheet[0] = val;
          let pageData = {
            isDefault: true, //是否切换栏数了
          };
          // cardOperate.operatePageCell(pageData).then((data) => {
          //   this.localityAnswerSheet = JSON.parse(
          //     JSON.stringify(this.answerSheet)
          //   );
          // });
        })
        .catch(() => {
          this.answerSheetAction({ acCardPanes: this.cacheAcCardPanes });
          // this.localityAnswerSheet.acCardPanes = this.oldAnswerSheet[0];
        });
    },
    //
    cardYJTypeChange(v) {
      console.log("=====RightMenu==cardYJTypeChange===")
      this.$confirm("改变后会影响页面布局以及题型选项，确定改变吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await this.resetPageCellContentHeight({
          acCardStudentCodeType: this.modelType,
        });
        this.answerSheetAction({ acCardYJType: v });
        console.log(this.subjects)
        this.subjects.forEach((subject, index) => {
          if (subject.type == 1) {
            // 只有手批的时候 才有小题给分 网阅没有
            // acCardYJType 1 网阅 0 手批 2 手批
            subject.eachBlankScore = v == 0 ? true : false;
            this.updateSubjectIdx = index
            this.updateSubjectsByindex(subject);
          }
        });
        //
      });
    },
    async updateSubjectsByindex(updateSubject) {
      const index = this.updateSubjectIdx;
      // 这里的编辑更新肯定需要更改题型的html和高度 不可能保存之前的数据
      updateSubject.setFromEdit(true);
      await this.updateSubjects({
        index: index,
        data: updateSubject,
      });
      await this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: index,
        acCardStudentCodeType: this.modelType,
      });
      if (updateSubject.type != 2) {
        return;
      }
      // 这样写是为了 dom更新之后 处理选择题 精确计算选择题的高度
      updateSubject = await setObjectiveHeight(updateSubject);
      await this.updateSubjects({
        index: index,
        data: new ObjectiveModel(updateSubject),
      });
      await this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: index,
        acCardStudentCodeType: this.modelType,
      });
    },
    //颜色
    cardColorChange(color) {
      this.answerSheetAction({ acCardColor: color });
      const root = document.documentElement;
      root.style.setProperty("--card-color", color);
    },
    codeNumChange(val) {
      // 改变考号位数
      this.answerSheetAction({ acCardExamNumber: val });
    },
    cardHideScoreChange() {
      this.answerSheetAction({
        acCardHideScore: !this.answerSheet.acCardHideScore,
      });
    },
    //缺考
    absentChange() {
      this.answerSheetAction({
        acCardMissSign: !this.answerSheet.acCardMissSign,
      });
    },
    //单双面
    acCardPintChange() {
      this.$confirm("修改后自定义编辑的内容会消失，确定修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let acCardPint = 2;
          //单面打印：1-单面  2-双面 默认双面
          if (v) {
            acCardPint = 1;
          }
          this.answerSheetAction({ acCardPint: acCardPint });
          this.resetPageCell({
            acCardPanes: this.answerSheet.acCardPanes,
            hurdleReset: true,
          });
        })
        .catch(() => {
          this.myAcCardPint = !this.myAcCardPint;
        });
    },
    //ab卷
    acCardABSetChange() {
      this.answerSheetAction({ acCardABSet: !this.answerSheet.acCardABSet });
    },
    acCardHideOrcodeChange() {

      this.answerSheetAction({ acCardHideOrcode: !this.answerSheet.acCardHideOrcode });
      this.acCardHideOrcode = this.answerSheet.acCardHideOrcode;
      this.$emit('hand-data', this.answerSheet.acCardHideOrcode);
    },
    acCardSpacingChange() {
      this.answerSheetAction({ acCardSpacing: !this.answerSheet.acCardSpacing });
      this.$emit('hand-data-spacing', this.answerSheet.acCardSpacing);
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/card.scss");

.CARD_Right_Container[data-v-ea095244] {
  width: 295px;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
  box-shadow: -5px 0 10px -5px rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.card-Layout-container {
  .card-layout-pic {
    margin-bottom: 4px;
    height: 50px;
    border-radius: 5px;
    overflow: hidden;
    transition: all 0.1s ease-in-out;
  }

  acCardPanes .card-layout-active .card-layout-pic {
    border: 2.5px solid #409eff !important;
    transition: all 0.1s ease-in-out;
  }

  .card-layout:hover .card-layout-pic {
    cursor: pointer;
    border: 2.5px solid #409eff;
    transition: all 0.1s ease-in-out;
  }

  .card-layout-active .card-layout-pic {
    border: 2.5px solid #409eff !important;
    transition: all 0.1s ease-in-out;
  }

  .card-layout-one {
    width: 40px;
    border: 2.5px solid #dcdfe6;
  }

  .card-layout-two {
    width: 80px;
    border: 2.5px solid #dcdfe6;
    display: flex;
    justify-content: center;
  }

  .card-layout-thr {
    width: 80px;
    border: 2.5px solid #dcdfe6;
    display: flex;
    justify-content: space-evenly;
  }

  .selector-btn-active {
    border: 2.5px solid #409eff !important;
  }
}

.exam-num {
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
}
</style>
